<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>品类信息</span>
      </div>
      <el-form
        ref="brandForm"
        :model="brandInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <span>品类一旦新增，生成数据后将无法删除，请谨慎操作</span>
        </div>
        <br />
        <div class="add-form-item">
          <el-form-item label="品牌：" prop="brandName">
            <el-input v-model="brandInfo.brandName" :disabled="true"></el-input>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="品类编码：" prop="categoryCode">
            <el-input v-model="brandInfo.categoryCode"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 2位正整数</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="请输入品类名称：" prop="categoryName">
            <el-input v-model="brandInfo.categoryName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过20个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      brandInfo: {
        brandId: "",
        brandCode: "",
        categoryCode: "",
        brandName: "",
        categoryName: ""
      },
      rules: {
        categoryCode: [
          {
            validator: this.validateCom,
            message: "2位正整数",
            trigger: "blur"
          }
        ],
        categoryName: [
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    //校验品类
    validateCom(rule, value, callback) {
      const one = Number(value);
      if (Number.isInteger(one)) {
        if (one < 10) {
          return callback(new Error("输入值必须大于9}"));
        } else if (one > 99) {
          return callback(new Error("输入值必须小于100"));
        }
        return callback();
      }
      return callback(new Error("输入值必须为正整数"));
    },
    getBrandTypeById: function(id) {
      let _this = this;
      let param = {
        url: "/api/dictionaryBrand/getDictionaryBrandInfoById",
        params: {
          brandId: id
        }
      };

      _this.$store.dispatch("getBrandTypeById", param).then(() => {
        _this.brandInfo =
          _this.$store.state.brandType.brandTypeInfoData.brandInfo;
      });
    },
    //新增品类
    add: function() {
      let _this = this;
      _this.$refs.brandForm.validate(isPass => {
        if (isPass) {
          let param;
          param = {
            url: "/api/dictionaryBrand/saveDictionaryBrandInfo",
            params: {
              brandId: _this.brandInfo.brandId,
              brandCode: _this.brandInfo.categoryCode,
              brandName: _this.brandInfo.categoryName
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "品类信息添加成功",
                  type: "success"
                });
                this.$router.push({
                  name: "brandTypeIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善品类信息!",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    let _this = this;
    let id = this.$route.params.brandId;
    if (id !== null && id !== "" && id !== undefined) {
      _this.getBrandTypeById(id);
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
